"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FilterOwnersUncontrolled = _interopRequireDefault(require("./FilterOwnersUncontrolled"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class FilterOwnersControlled extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      q: "",
      filteredOwners: []
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.owners !== this.props.owners) {
        this.filterOwners();
      }

      if (prevState.q !== this.state.q) {
        this.filterOwners();
      }
    });

    _defineProperty(this, "filterOwners", () => {
      const owners = this.props.owners;
      const q = this.state.q;
      const filteredOwners = owners.filter(owner => {
        const title = owner.title;

        if (q && !title.toLowerCase().includes(q.toLowerCase())) {
          return false;
        }

        return true;
      });
      this.setState({
        filteredOwners: filteredOwners
      });
    });

    _defineProperty(this, "onSearch", (q, event) => {
      event.preventDefault();
      this.setState({
        q: q
      });
    });
  }

  componentDidMount() {
    this.filterOwners();
  }

  render() {
    const _this$state = this.state,
          q = _this$state.q,
          filteredOwners = _this$state.filteredOwners;
    return _react.default.createElement(_FilterOwnersUncontrolled.default, _extends({}, this.props, {
      q: q,
      onSearch: this.onSearch,
      owners: filteredOwners
    }));
  }

}

_defineProperty(FilterOwnersControlled, "defaultProps", {
  owners: []
});

var _default = FilterOwnersControlled;
exports.default = _default;
module.exports = exports.default;